// 商品类型
export const SKU_TYPE = {
  // 组合商品
  GROUP: 'sku_group',
  // 普通商品
  SPU: 'spu',
}
